import React from 'react';
import clsx from 'clsx';
import OpenInFullOutlinedIcon from '@mui/icons-material/OpenInFullOutlined';
import PlayArrowOutlinedIcon from '@mui/icons-material/PlayArrowOutlined';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import { useTranslation } from 'react-i18next';

import StoryButton from '../../../../components/story-button/StoryButton';
import StoryCheckbox from '../../../../components/story-checkbox/StoryCheckbox';
import StoryBadge from '../../../../components/story-badge/StoryBadge';
import StoryMediaView from '../../../../components/story-media-view/StoryMediaView';
import useStoryMediaDisplay from '../../../../hooks/useStoryMediaDisplay';

import scss from './MediaPoolCard.module.scss';

function MediaPoolCard({ media, isSelected, onSelect, onPreview }) {
  const { t } = useTranslation('story');
  const { isVideo } = useStoryMediaDisplay(media);

  const handleSelect = () => {
    onSelect(media);
  };

  const handlePreview = (event) => {
    event.stopPropagation();
    onPreview(media);
  };

  return (
    <div className={scss.card}>
      <button type='button' className={clsx(scss.inner, isSelected && scss.selected)} onClick={handleSelect}>
        <StoryMediaView media={media} variant='card' className={scss.media} />

        {isVideo ? (
          <>
            <span className={scss.playIcon} aria-hidden='true'>
              <PlayArrowOutlinedIcon />
            </span>
            <StoryBadge icon={VideocamOutlinedIcon} label={t('video')} size='sm' className={scss.videoBadge} />
          </>
        ) : null}

        {isSelected ? <StoryCheckbox checked readOnly size='sm' className={scss.selectionCheckbox} /> : null}
      </button>

      <StoryButton
        icon={OpenInFullOutlinedIcon}
        onClick={handlePreview}
        ariaLabel={t('preview')}
        size='sm'
        className={scss.previewButton}
      />
    </div>
  );
}

export default MediaPoolCard;
